module.exports = __webpack_public_path__ + "static/media/card-icon-05.d57f840a.svg";